/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CertificateAlgorithmDto } from '../models/certificate-algorithm-dto';

@Injectable({
  providedIn: 'root',
})
export class CertificateMgmtUtilityControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getListOfValues
   */
  static readonly GetListOfValuesPath = '/api/v1/cert/listofvalues';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListOfValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListOfValues$Response(params?: {
  }): Observable<StrictHttpResponse<CertificateAlgorithmDto>> {

    const rb = new RequestBuilder(this.rootUrl, CertificateMgmtUtilityControllerService.GetListOfValuesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CertificateAlgorithmDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getListOfValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListOfValues(params?: {
  }): Observable<CertificateAlgorithmDto> {

    return this.getListOfValues$Response(params).pipe(
      map((r: StrictHttpResponse<CertificateAlgorithmDto>) => r.body as CertificateAlgorithmDto)
    );
  }

}
